module.exports = __webpack_public_path__ + "img/livraison client.ddd12990.png";